export enum Statuses {
  'I’ll do it later' = 0,
  'Working on it' = 1,
  'My job here is done' = 2,
}
